/*
  此公共方法为微信分享配置方法，因每个页面都需要配置分享参数。参数有默认的内容，可不填, 页面created时需调用 this.$store.dispatch('share/updateShareParams')
  若需要单独配置。使用：this.$store.dispatch('share/updateShareParams')
  参数必须规范： { title, desc, link, imgUrl }
*/
import { appid } from "@/common/common.js"
import { api_wxSign } from '@/api'
import { $inWeChat, $getUrlParam }  from "@/common/common.js"

// 是否一进初始化，防止在不刷新页面的情况下多次初始化
let isInit = false

// 默认的分享参数
const getDefaultState = () => {
  return {
    title: document.title,
    desc: '',
    link: configShareLink(),
    imgUrl: 'https://szone-activity.7net.cc/views/groupon/static/imgs/share-img.jpg',
  }
}

// 初始化微信jdk
const initWxConfig = (params, state) => {
  $inWeChat && !isInit && wx && wx.config({
    debug: false,
    appId: appid,
    timestamp: params.timestamp,
    nonceStr: params.nonceStr,
    signature: params.signature,
    // jsApiList: ['hideAllNonBaseMenuItem'],
    jsApiList: ['updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'showMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData']
  })
  isInit = true
}

// 微信分享的url移除不需要的参数
const configShareLink = (link) => {
  let newLink = link || window.location.href
  let linkParams = $getUrlParam(newLink)
  if (linkParams.payCode) delete linkParams.payCode // 可能出现的订单号
  let query = $.param(linkParams)
  newLink = newLink.split('?')[0] + (query ? ('?' + query) : '')
  return newLink
}

// 配置微信分享的内容
const configWxMenuItems = (state) => {
  // 微信分享的url移除不需要的参数
  state.link = configShareLink(state.link)
  $inWeChat && wx && wx.ready(function() {
    // wx.hideAllNonBaseMenuItem()
    wx.showMenuItems({
      // 要显示的菜单项
      menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:copyUrl', 'menuItem:openWithSafari', 'menuItem:favorite']
    })
    // 老版本兼容
    // 请注意，原有的 wx.onMenuShareTimeline、wx.onMenuShareAppMessage、wx.onMenuShareQQ、wx.onMenuShareQZone 接口，即将废弃
    // 请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、wx.updateTimelineShareData接口。
    // See: https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html
    function oldConfig() {
      wx.onMenuShareAppMessage(state)
      wx.onMenuShareTimeline(state)
      wx.onMenuShareQQ(state)
      wx.onMenuShareQZone(state)
    }
    if (wx.checkJsApi) {
      wx.checkJsApi({
        // jsApiList: ['hideAllNonBaseMenuItem'],
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'showMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData'],
        success: function(res) {
          if (res.checkResult.updateAppMessageShareData && res.checkResult.updateTimelineShareData) {
            wx.updateTimelineShareData({
              ...state,
              fail: () => oldConfig()
            })
            wx.updateAppMessageShareData({
              ...state,
              fail: () => oldConfig()
            })
          } else {
            oldConfig()
          }
        }
      })
    } else {
      oldConfig()
    }
  })
}

// 配置meta标签的HTML参数，用于传统分享（QQ、浏览器等）
const configMetaContent = (state) => {
  // 8月10日，应产品要求，不做分享功能
  $("meta[itemprop='name']").attr('content', state.title)
  $("meta[itemprop='description']").attr('content', state.desc)
  $("meta[itemprop='image']").attr('content', state.imgUrl)
}

const state = getDefaultState()

const mutations = {
  SET_SHARE_PARAMS: (state, params) => {
    // 初始化分享参数
    state = Object.assign({}, getDefaultState())
    // 若有初始化的参数，则合并参数内容
    if (params.state) state = Object.assign(state, params.state)
    if (params.data) initWxConfig(params.data, state)
    if (isInit) configWxMenuItems(state)
    configMetaContent(state)
  }
}

const actions = {
  // 初始化微信分享并配置默认分享样式
  initShareParams({ commit }, params) {
    if (!isInit) {
      api_wxSign({
        url: window.location.href
      }).then(res => {
        if (res.status === 200) commit('SET_SHARE_PARAMS', {
          data: res.data,
          state: params
        })
      })
    } else {
      commit('SET_SHARE_PARAMS', {
        state: params
      })
    }
  }
}

// 外界获取分享参数
const getters = {
  shareParams: state => state
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: getters
}
